// extracted by mini-css-extract-plugin
module.exports = {"filterBarContainer":"FilterBar_filterBarContainer__3rqPJ","resultsText":"FilterBar_resultsText__1fEAT"};